// src/web/ContactPage.jsx

import ContactFormComponent from '../../components/modals/web-modals/components/contactFormComponent'; 

const ContactPage = () => {

    return (
        <div className="contact-page">
            <div className="contact-form-wrapper">
                <ContactFormComponent />
            </div>
        </div>
    );
};

export default ContactPage;